export default {
  data: () => ({
    loading: false,
    activeInput: undefined,
    errors: [],
    params: {
      name: null,
      email: null,
      phone: null,
      message: null,
    },
  }),
  methods: {
    validateFields() {
      this.errors = [];
      if (!this.params.name) {
        // TODO: design errors
        this.errors.push("Palun sisestage oma nimi.");
      }
      if (!this.params.phone && !this.params.email) {
        this.errors.push(
          "Ühenduse võtmiseks oleks meil vaja Teie e-maili või telefoninumbrit :)"
        );
      }
    },
    onContactSubmit() {
      this.validateFields();
      if (!this.errors.length) {
        this.insertMessage();
      }
    },
    resetComponentState() {
      this.activeInput = undefined;
      this.params.name = null;
      this.params.email = null;
      this.params.phone = null;
      this.params.message = null;
    },
  },
};
